import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaShieldAlt, FaFileContract, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0A1929] to-[#1E3A5F]">
      {/* Header */}
      <div className="bg-[#1A2942] border-b border-[#2D5A8F] sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/register" className="flex items-center text-gray-300 hover:text-[#FFD700] transition-colors">
            <FaArrowLeft className="mr-2" />
            <span>Back to Registration</span>
          </Link>
          <div className="flex items-center space-x-2">
            <FaShieldAlt className="text-[#FFD700]" />
            <span className="text-white font-bold">Arth Gurukul</span>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-gradient-to-br from-[#1A2942] to-[#1E3A5F] rounded-xl border border-[#2D5A8F] p-8 shadow-2xl">
          {/* Title */}
          <div className="text-center mb-8 pb-6 border-b border-[#2D5A8F]">
            <div className="flex items-center justify-center mb-4">
              <FaFileContract className="text-[#FFD700] text-4xl" />
            </div>
            <h1 className="text-3xl font-bold text-white mb-2">TERMS & CONDITIONS</h1>
            <h2 className="text-xl text-[#FFD700] font-semibold">Arth Gurukul</h2>
            <p className="text-gray-400">(An Initiative of MDRT School)</p>
            <div className="mt-4 flex items-center justify-center space-x-4 text-sm text-gray-400">
              <span>Effective Date: 27th Feb 2026</span>
              <span className="text-[#FFD700]">|</span>
              <span>Version: 1.0</span>
            </div>
          </div>

          {/* Terms Content */}
          <div className="prose prose-invert max-w-none space-y-8 text-gray-300">
            
            {/* Section 1 */}
            <section>
              <h3 className="text-xl font-bold text-[#FFD700] mb-3">1. Introduction</h3>
              <p>These Terms & Conditions ("Terms") govern the access and use of the Arth Gurukul platform ("Platform", "we", "us", "our").</p>
              <p>By accessing or using the Platform, you ("User", "Advisor") agree to be legally bound by these Terms.</p>
              <p className="font-semibold text-white">If you do not agree, you must not use the Platform.</p>
            </section>

            {/* Section 2 */}
            <section>
              <h3 className="text-xl font-bold text-[#FFD700] mb-3">2. Nature of the Platform</h3>
              <p>Arth Gurukul is a:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Financial literacy tool</li>
                <li>Goal-based financial planning dashboard</li>
                <li>Analytical and projection-based reporting system</li>
              </ul>
              <p className="mt-4">The Platform:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Does not execute investment transactions</li>
                <li>Does not act as a stockbroker, mutual fund distributor, insurance company, or portfolio manager</li>
                <li>Does not guarantee financial returns</li>
              </ul>
              <p className="mt-4 font-semibold text-white">All financial decisions remain the responsibility of the user and/or their licensed advisor.</p>
            </section>

            {/* Section 3 */}
            <section>
              <h3 className="text-xl font-bold text-[#FFD700] mb-3">3. Eligibility</h3>
              <p>You must:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Be at least 18 years of age</li>
                <li>Provide accurate information</li>
                <li>Have legal capacity to enter into a contract</li>
              </ul>
              <p className="mt-4">If registering as an advisor, you confirm that you hold all required regulatory licences (if applicable).</p>
            </section>

            {/* Section 4 */}
            <section>
              <h3 className="text-xl font-bold text-[#FFD700] mb-3">4. User Responsibilities</h3>
              <p>You agree to:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Provide accurate and complete information</li>
                <li>Update your financial information when necessary</li>
                <li>Maintain confidentiality of login credentials</li>
                <li>Use the Platform lawfully</li>
              </ul>
              <p className="mt-4 font-semibold text-white">You are responsible for all activity under your account.</p>
            </section>

            {/* Section 5 */}
            <section>
              <h3 className="text-xl font-bold text-[#FFD700] mb-3">5. Advisor Responsibilities</h3>
              <p>Advisors using the Platform agree to:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Use client data only for lawful advisory purposes</li>
                <li>Maintain confidentiality</li>
                <li>Comply with applicable regulations</li>
                <li>Not misrepresent projections or outputs</li>
              </ul>
              <p className="mt-4">The Platform is not responsible for advice independently given by Advisors.</p>
            </section>

            {/* Section 6 */}
            <section>
              <h3 className="text-xl font-bold text-[#FFD700] mb-3">6. Financial Projections Disclaimer</h3>
              <p>All financial projections, calculations, gap analysis, and goal estimations:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Are based on user-provided inputs and assumptions</li>
                <li>Are illustrative in nature</li>
                <li>May vary due to market risks, inflation, tax changes, or economic conditions</li>
              </ul>
              <p className="mt-4 font-semibold text-white">We do not guarantee accuracy or future performance.</p>
            </section>

            {/* Section 7 */}
            <section>
              <h3 className="text-xl font-bold text-[#FFD700] mb-3">7. Fees & Payments</h3>
              <p>Where applicable:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Subscription or service fees may apply (e.g., ₹499 per year or other pricing as published).</li>
                <li>Fees are payable in advance.</li>
                <li>Payment once made is non-transferable.</li>
                <li>Refund policies, if applicable, shall be governed by the Refund Policy page.</li>
              </ul>
              <p className="mt-4">We reserve the right to revise pricing with prior notice.</p>
            </section>

            {/* Section 8 */}
            <section>
              <h3 className="text-xl font-bold text-[#FFD700] mb-3">8. Intellectual Property</h3>
              <p>All content, including:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Dashboard design</li>
                <li>Financial scoring models</li>
                <li>Training videos</li>
                <li>eBooks</li>
                <li>Reports</li>
                <li>Branding elements</li>
              </ul>
              <p className="mt-4">Are the exclusive intellectual property of Arth Gurukul and/or its licensors.</p>
              <p className="mt-4">Users may not:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Copy</li>
                <li>Reproduce</li>
                <li>Distribute</li>
                <li>Reverse engineer</li>
                <li>Commercially exploit</li>
              </ul>
              <p className="mt-2">Without written permission.</p>
            </section>

            {/* Section 9 */}
            <section>
              <h3 className="text-xl font-bold text-[#FFD700] mb-3">9. Data Protection</h3>
              <p>Your personal data will be processed in accordance with our Privacy Policy.</p>
              <p>By using the Platform, you consent to data processing as described therein.</p>
            </section>

            {/* Section 10 */}
            <section>
              <h3 className="text-xl font-bold text-[#FFD700] mb-3">10. Account Suspension or Termination</h3>
              <p>We reserve the right to:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Suspend access</li>
                <li>Terminate accounts</li>
                <li>Restrict services</li>
              </ul>
              <p className="mt-4">If:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>False information is provided</li>
                <li>Terms are violated</li>
                <li>Data misuse occurs</li>
                <li>Unlawful activity is detected</li>
              </ul>
              <p className="mt-4">Confidentiality obligations survive termination.</p>
            </section>

            {/* Section 11 */}
            <section>
              <h3 className="text-xl font-bold text-[#FFD700] mb-3">11. Limitation of Liability</h3>
              <p>To the maximum extent permitted by law:</p>
              <p className="mt-2">Arth Gurukul shall not be liable for:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Investment losses</li>
                <li>Market fluctuations</li>
                <li>Advisor misconduct</li>
                <li>User input errors</li>
                <li>Indirect or consequential damages</li>
              </ul>
              <p className="mt-4 font-semibold text-white">Our total liability shall not exceed the amount paid by the User in the preceding 12 months.</p>
            </section>

            {/* Section 12 */}
            <section>
              <h3 className="text-xl font-bold text-[#FFD700] mb-3">12. No Professional Relationship</h3>
              <p>Use of the Platform does not create:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>A fiduciary relationship</li>
                <li>An investment advisory relationship</li>
                <li>An insurance brokerage relationship</li>
                <li>A partnership or agency relationship</li>
              </ul>
              <p className="mt-4">Between the Platform and the User.</p>
            </section>

            {/* Section 13 */}
            <section>
              <h3 className="text-xl font-bold text-[#FFD700] mb-3">13. Third-Party Links</h3>
              <p>The Platform may contain links to third-party websites.</p>
              <p>We are not responsible for:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Their content</li>
                <li>Their data practices</li>
                <li>Their services</li>
              </ul>
            </section>

            {/* Section 14 */}
            <section>
              <h3 className="text-xl font-bold text-[#FFD700] mb-3">14. Force Majeure</h3>
              <p>We shall not be liable for delays or failure caused by:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Natural disasters</li>
                <li>Cyber attacks</li>
                <li>Government restrictions</li>
                <li>Server failures</li>
                <li>Network outages</li>
              </ul>
            </section>

            {/* Section 15 */}
            <section>
              <h3 className="text-xl font-bold text-[#FFD700] mb-3">15. Modification of Terms</h3>
              <p>We reserve the right to modify these Terms.</p>
              <p>Material updates will be communicated via:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Email</li>
                <li>Dashboard notification</li>
              </ul>
              <p className="mt-4">Continued use constitutes acceptance of updated Terms.</p>
            </section>

            {/* Section 16 */}
            <section>
              <h3 className="text-xl font-bold text-[#FFD700] mb-3">16. Governing Law & Jurisdiction</h3>
              <p>These Terms shall be governed by the laws of India.</p>
              <p className="font-semibold text-white">Courts located in Pune shall have exclusive jurisdiction.</p>
            </section>

            {/* Section 17 */}
            <section>
              <h3 className="text-xl font-bold text-[#FFD700] mb-3">17. Grievance Redressal</h3>
              <p>For complaints or concerns:</p>
              <div className="mt-4 bg-[#0F172A] rounded-lg p-4 border border-[#2D5A8F]">
                <p className="flex items-center mb-2">
                  <span className="text-gray-400 w-32">Grievance Officer:</span>
                  <span className="text-white font-medium">Jibal Bobby</span>
                </p>
                <p className="flex items-center mb-2">
                  <FaEnvelope className="text-[#FFD700] mr-2" />
                  <span className="text-gray-400 w-28">Email:</span>
                  <a href="mailto:care@mdrtschool.com" className="text-[#FFD700] hover:underline">care@mdrtschool.com</a>
                </p>
                <p className="flex items-start">
                  <FaMapMarkerAlt className="text-[#FFD700] mr-2 mt-1 flex-shrink-0" />
                  <span className="text-gray-400 w-28 flex-shrink-0">Registered Office:</span>
                  <span className="text-white">Financial Nirvana, Benevolent Private Spaces LLP, Flat No. B-1002, Heritage Palace, WANAWADI, Road: KEDARI NAGAR, Pune, Maharashtra, 411040</span>
                </p>
              </div>
              <p className="mt-4">We aim to respond within a reasonable time.</p>
            </section>

          </div>

          {/* Footer */}
          <div className="mt-8 pt-6 border-t border-[#2D5A8F] text-center">
            <div className="flex flex-wrap justify-center gap-4">
              <Link 
                to="/privacy-policy" 
                className="inline-flex items-center px-4 py-2 bg-[#1E3A5F] text-white rounded-lg hover:bg-[#2D5A8F] transition-all border border-[#2D5A8F]"
              >
                View Privacy Policy
              </Link>
              <Link 
                to="/register" 
                className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-[#D4AF37] to-[#FFD700] text-[#0A1929] font-bold rounded-lg hover:from-[#FFD700] hover:to-[#D4AF37] transition-all"
              >
                <FaArrowLeft className="mr-2" />
                Back to Registration
              </Link>
            </div>
          </div>
        </div>

        {/* Page Footer */}
        <div className="mt-8 text-center text-gray-400 text-xs">
          <p>© 2026 Arth Gurukul. All rights reserved.</p>
          <p className="mt-1">An Initiative of MDRT School</p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
